import { Company } from '@/models/companies/company';
import { axiosService } from '.';

export default class CompaniesService {
    public async getCompany(id: number): Promise<Company> {
        return new Company(
            (await axiosService.instance.get(`companies/organization/${id}`)).data,
        );
    }
}

export const companiesService = new CompaniesService();
